export function isComplete(report) {
  return report && report.length > 0 && report[0]?.[4]?.isComplete;
}
